import {
  TOrderCreate,
} from '@/types/order.ts';

const strategy: Record<TOrderCreate['target']['strategy'], string> = {
  weight: 'Weight',
  quantity: 'Quantity',
};

export default strategy;
